import React from "react";

const BxlTwitterIcon: React.FC = () => (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2331 3.98747C19.247 4.16289 19.247 4.3373 19.247 4.51171C19.247 9.84939 14.916 16 7.00094 16C4.56241 16 2.297 15.3374 0.390625 14.1867C0.736849 14.2238 1.07025 14.2368 1.43037 14.2368C3.44253 14.2368 5.2944 13.5993 6.7744 12.5117C4.88192 12.4746 3.29613 11.3119 2.74901 9.71207C3.01509 9.74915 3.28224 9.77421 3.56221 9.77421C3.94797 9.77421 4.33587 9.72409 4.69599 9.63689C2.7223 9.262 1.24443 7.63714 1.24443 5.67448V5.62436C1.81827 5.92407 2.484 6.11151 3.18927 6.13657C2.02985 5.41286 1.27008 4.17492 1.27008 2.77459C1.27008 2.02481 1.48273 1.33718 1.85567 0.737752C3.97469 3.18657 7.16016 4.78737 10.7314 4.96279C10.6652 4.66207 10.6245 4.35033 10.6245 4.03759C10.6245 1.8123 12.5437 0 14.9288 0C16.1684 0 17.2872 0.487157 18.0737 1.27503C19.0461 1.09961 19.9779 0.761809 20.805 0.299712C20.4855 1.23694 19.8048 2.02481 18.9126 2.525C19.7792 2.43679 20.6191 2.21225 21.3906 1.89951C20.805 2.69941 20.073 3.4121 19.2331 3.98747Z"
        fill="white"
      />
    </svg>
  );

export default BxlTwitterIcon;
